import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {PrivateLocation} from "@/lib/types/monitoring.ts";
import {PrivateLocationForm} from "@/pages/monitoring/privatelocations/edit/PrivateLocationForm.tsx";

interface EditPrivateLocationModalProps {
  location: PrivateLocation;
  show: boolean;
  hide: () => void;
}

const formId = "private-location-form";

export const EditPrivateLocationModal = ({location, show, hide}: EditPrivateLocationModalProps) => {
  return (
    <FormModal title="Rename Private Location" onCancel={hide} show={show} size="lg" formId={formId} hasRequiredFields>
      <PrivateLocationForm location={location} formId={formId} onSave={hide} />
    </FormModal>
  );
};
